<template>
  <div>
    <header-bar>支払い申請</header-bar>
    <account-information
      v-if="display === 'user-data-input'"
      back-button-text="戻る"
      :hide-steps="true"
      :company-id="$store.state.auth.company.id"
      @showSection="show('confirm-user-data')" />
    <confirm-account-information
      v-else-if="display === 'confirm-user-data'"
      :hide-steps="true"
      :company-id="$store.state.auth.company.id"
      @show="show" />
    <mobile-registration
      v-else-if="display === 'mobile-input'"
      :is-first-time="isFirstTime"
      :saved-mobile="mobileNumber"
      :hide-steps="true"
      @onMobileReturnClicked="onMobileReturnClicked"
      @smsResponse="smsResponse($event)" />
    <security-code-registration
      v-else-if="display === 'security-code-input'"
      :mobile-number="mobileNumber"
      :is-subscriber="isSubscriber"
      :hide-steps="true"
      next-page-title="支払い申請"
      :is-payment="true"
      @setErrorMessage="setErrorMessage"
      @emitIsFirstTime="handleFirstTime"
      @displayMobileRegistration="displayMobileRegistration()"
      @securityCodeResponse="securityCodeResponse($event)" />
    <template v-else-if="display === 'top'">
      <div class="page-block">
        <div class="page-block__heading page-block__heading--withbar">
          <h3 class="page-block__title">お支払い</h3>
        </div>
        <div
          v-if="subscriptionDefaulted || subscriptionCarrierFeePending"
          class="payment-error">
          <p v-if="subscriptionDefaulted">
            サブスクプランのお支払いの確認ができておりません。<br>
            確認できるまでは支払い申請ができませんので、ご了承ください。<br>
            決済情報の更新をお願いいたします。
          </p>
          <p
            v-if="subscriptionCarrierFeePending"
            class="subscription-carrier-fee-pending-notification">
            【重要なお知らせ】<br>
            <br>
            サブスクプランの料金改定に伴い、下記の期限までに決済情報の再登録が必要となります。<br>
            <br>
            期限：2024年 2月29日 23時59分<br>
            <br>
            決済情報の再登録が完了するまで、支払い申請を含む一部のサービスをご利用いただくことができません。<br>
            お手数ですが、右記の「決済情報を更新する」より<span>決済情報の再登録をお願いいたします。</span><br>
            <br>
            期限内に決済情報の再登録が完了しない場合、楽曲の配信停止および退会の手続きを取らせていただきます。<br>
            退会に伴いまして、<span>残高に計上されている収益をお支払することができなくなります。</span><br>
            予めご了承ください。<br>
          </p>
          <div class="c-btn-wrap">
            <router-link
              :to="{name: 'settlement-method-change'}"
              class="c-btn">
              決済情報を更新する
              <span class="c-btn__icon-arrow"></span>
            </router-link>
          </div>
        </div>
        <div class="payment-block__inner">
          <alert-view :errors="errors" />

          <div
            v-if="isBankError===true"
            class="profile-edit">
            <router-link
              :to="{ name : 'bank-edit' }"
              class="c-text-link">
              <span v-if="isEmptyBank">振込口座が未登録ですので、こちらから登録してください。</span>
              <span v-else>振込口座に誤りがありますので、こちらから登録してください。</span>
            </router-link>
          </div>

          <div class="payment-about">
            <balance-report
              :hide="true"
              :hiden-payment="true"></balance-report>
            <div class="payment-about__block pcmt20">
              <div class="payment-about__text">
                ご希望のお支払金額を「お支払い金額」のご入力ください。<br>
                支払スケジュールは毎月月末締めの翌月末日にお支払いとなります。
              </div>
              <div class="payment-about__text--caution">
                ※銀行休業日の場合は、前営業日となります。<br>
                ※{{ roundNumber('positive',minimumTransferPrice,1) }}円以上から支払い申請が可能となります。
              </div>
            </div>
          </div>
          <div class="payment-breakdown-info-list">
            <table class="payment-breakdown-info-list__table">
              <tbody
                class="payment-breakdown-info-list__tbody">
                <tr>
                  <th>お支払い金額</th>
                  <td class="payment-breakdown-list__cell-money">
                    <input
                      v-model="item.money"
                      class="payment-price__input"
                      oninput="value =
                      String(value.replace(/[０-９]/g,
                      function(s){return String.fromCharCode(s.charCodeAt(0)-0xFEE0);})
                      .replace(/[^0-9]+/i,''));">
                    <p
                      v-if="errors.money"
                      class="error-text">
                      {{ errors.money[0] }}
                    </p>
                  </td>
                </tr>
                <tr v-show="false">
                  <th>源泉徴収</th>
                  <td>
                    <div class="withholding_tax__block">
                      <div class="radio">
                        <label for="enable_withholding_tax_yes">
                          <input
                            id="enable_withholding_tax_yes"
                            v-model="item.enable_withholding_tax"
                            type="radio"
                            name="enable_withholding_tax"
                            :value="1">
                          <div class="option-input"></div> 源泉徴収する
                        </label>
                      </div>
                      <div class="radio">
                        <label for="enable_withholding_tax_no">
                          <input
                            id="enable_withholding_tax_no"
                            v-model="item.enable_withholding_tax"
                            type="radio"
                            name="enable_withholding_tax"
                            :value="0">
                          <div class="option-input"></div> 源泉徴収しない
                        </label>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-show="false">
                  <th>源泉徴収金額</th>
                  <td>
                    <span>
                      {{ roundNumber('negative',paymentBreakdown.withholding_tax,1) }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <th>手数料</th>
                  <td>
                    <span>
                      {{ roundNumber('negative',paymentBreakdown.transfer_fee,1) }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <th>お振込金額</th>
                  <td>
                    <span>
                      {{ roundNumber('positive',paymentBreakdown.transfer_amount,1) }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <th>収益残高</th>
                  <td>
                    <span>
                      {{ roundNumber('positive',paymentBreakdown.deduction_balance,100) }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="payment-bank-info-list">
            <table class="payment-bank-info-list__table">
              <tbody
                v-for="bank in item.banks"
                :key="bank.index"
                class="payment-bank-info-list__tbody">
                <tr>
                  <th>銀行名</th>
                  <td>{{ bank.bank_name }} ({{ bank.bank_code }})</td>
                </tr>
                <tr>
                  <th>支店名</th>
                  <td>{{ bank.bank_branch_name }} ({{ bank.bank_branch_code }})</td>
                </tr>
                <tr>
                  <th>口座種別</th>
                  <td>{{ bank.bank_account_type | toAccountType }}</td>
                </tr>
                <tr>
                  <th>口座番号</th>
                  <td>{{ bank.bank_account_code }}</td>
                </tr>
                <tr>
                  <th>口座名義</th>
                  <td>{{ bank.bank_account_name }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="c-btn-wrap c-btn-wrap--payment">
            <a
              class="c-btn"
              :class="{ 'c-btn--off': nextButtonDisabled() }"
              href="#"
              @click.prevent="onShowPaymentConfirm">
              <span>アカウント情報の確認へ</span>
              <span class="c-btn__icon-arrow"></span>
            </a>
          </div>
        </div>
      </div>
      <confirm-dialog
        name="paymentRequestShow"
        :is-shown="paymentConfirmShown"
        title="支払い申請"
        @closed="paymentConfirmShown = false"
        @default-clicked="onNextClicked"
        @cancel-clicked="paymentConfirmShown = false">
        <template #body>
          支払い申請を行います。<br />
          よろしいですか？
        </template>
      </confirm-dialog>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import qs from '../../../../../node_modules/qs'
import HeaderBar from '../HeaderBar'
import AlertView from '../AlertView'
import BalanceReport from '../Top/Dashboard/BalanceReport'
import ConfirmDialog from '../../../components/ConfirmDialog'
import AccountInformation from '../User/AccountInformation'
import ConfirmAccountInformation from '../User/ConfirmAccountInformation'
import account from '../../mixins/account'
import MobileRegistration from '../Mfa/PhoneRegistration'
import SecurityCodeRegistration from '../Mfa/SecurityCodeRegistration'

export default {
  components: {
    SecurityCodeRegistration,
    MobileRegistration,
    ConfirmAccountInformation,
    AccountInformation,
    HeaderBar,
    BalanceReport,
    AlertView,
    ConfirmDialog,
  },
  filters: {
    toAccountType: (value) => (value === '1' ? '当座' : '普通'),
  },
  mixins: [
    account,
  ],
  data() {
    return {
      display: 'top',
      userData: {},
      isCompleteAccount: false,
      mobileNumber: this.mobile,
      isFirstTime: true,
      item: {
        money: '',
        date: '',
        enable_withholding_tax: 0,
        banks: [],
        default_check: 0,
      },
      paymentConfirmShown: false,
      paymentBalance: '',
      paymentBreakdown: {
        balance: '',
        deduction_balance: '',
        transfer_amount: '',
        transfer_fee: '',
        withholding_tax: '',
      },
      // validBankInfo: false, // 口座登録OK
      errors: [],
      isBankError: false, // 口座登録情報誤り
      isEmptyBank: false, // 口座情報未登録
    }
  },
  computed: {
    minimumTransferPrice() {
      // 最低振込金額
      return (this.$store.state.auth.company.is_consumer === 0) ? 10000 : 1000
    },
    ...mapGetters('auth', ['subscriptionDefaulted', 'isSubscriber', 'subscriptionCarrierFeePending']),
  },
  watch: {
    'item.enable_withholding_tax': {
      handler() {
        this.fetchBreakdown()
      },
    },
    'item.money': {
      handler() {
        this.fetchBreakdown()
      },
    },
    'item.banks': {
      handler() {
        this.fetchBreakdown()
      },
    },
  },
  async mounted() {
    this.fetchItem()
    this.fetchBalance()

    this.userData = await this.getUser('payment-request')
    this.mobileNumber = this.userData.mobile_number ? `0${this.userData.mobile_number.replace(/^(\+81)/, '')}` : ''
    this.isCompleteAccount = this.checkIfUserDataAvailable(this.userData)
  },
  methods: {
    async fetchItem() {
      const { data } = await window.axios.get(`/api/client/users/${this.$store.state.auth.id}`)
      this.item.banks.push({
        bank_code: data.company.bank_code,
        bank_name: data.company.bank_name,
        bank_branch_code: data.company.bank_branch_code,
        bank_branch_name: data.company.bank_branch_name,
        bank_account_type: data.company.bank_account_type,
        bank_account_code: data.company.bank_account_code,
        bank_account_name: data.company.bank_account_name,
      })
      this.item.date = moment().format('YYYYMM')
    },
    async fetchBalance() {
      const { data } = await window.axios.get('/api/client/payments/balances')
      this.paymentBalance = data
      this.item.money = Math.floor(this.paymentBalance * 1) / 1
    },
    async fetchBreakdown() {
      try {
        this.errors = []
        if (this.item.money < this.minimumTransferPrice) {
          this.paymentBreakdown = {
            deduction_balance: this.paymentBalance,
          }
          return
        }
        if (this.item.banks.length === 0) {
          return
        }
        const { data } = await window.axios('/api/client/payments/breakdown', {
          method: 'get',
          params: this.item,
          paramsSerializer(params) {
            return qs.stringify(params)
          },
          responseType: 'json',
        })
        this.paymentBreakdown = data
        this.item.default_check = 1
      } catch ({ response }) {
        const { errors } = response.data
        this.errors = errors
        this.isBankError = Object.keys(errors).some(key => key.substr(0, 5) === 'banks')
        this.paymentBreakdown = []
        // errorsに errors[bank]があれば口座未登録
        this.isEmptyBank = 'bank' in this.errors
        if (this.isEmptyBank) {
          this.isBankError = true
          // 口座未登録の場合は他の口座エラーを削除
          const keys = Object.keys(this.errors)
          for (let i = 0, l = keys.length; i < l; i += 1) {
            if (keys[i].substr(0, 5) === 'banks') {
              delete this.errors[keys[i]]
            }
          }
        }
      }
    },
    async onDefaultClicked() {
      const params = this.item
      try {
        await window.axios.post('/api/client/payments/balances', params)
        window.scrollTo(0, 0)
        this.$router.push({ name: 'payment-complete' })
      } catch ({ response }) {
        const { errors } = response.data
        this.errors = errors
      }
      this.paymentConfirmShown = false
    },
    onShowPaymentConfirm() {
      window.scrollTo(0, 0)
      this.paymentConfirmShown = true
    },
    // 支払い申請の確定ボタン無効化
    nextButtonDisabled() {
      const missingBank = false
      if (this.isBankError === true) {
        return true
      }
      if (this.isEmptyBank === true) {
        return true
      }
      if (this.item.money < this.minimumTransferPrice) {
        return true
      }
      if (this.paymentBalance < this.item.money) {
        return true
      }
      if (this.subscriptionDefaulted) {
        return true
      }
      if (this.subscriptionCarrierFeePending) {
        return true
      }
      if (Object.keys(this.errors).length > 0) {
        return true
      }
      return missingBank
    },
    roundNumber(sign = 'positive', value = '', base = 1, currency = '¥') {
      if (value === '') return ''
      const minus = sign === 'negative' ? '-' : ''
      return `${currency}${minus}${value
        ? new Intl.NumberFormat('ja-JP').format(Math.round(value * base) / base)
        : 0}`
    },
    onNextClicked() {
      if (this.isCompleteAccount) {
        this.show('confirm-user-data')
      } else {
        this.show('user-data-input')
      }
    },
    show(section = '') {
      this.display = section
    },
    // handle operation after registering mobile number
    smsResponse({ mobileNumber }) {
      this.display = 'security-code-input'
      this.mobileNumber = mobileNumber
    },
    /* change text of mobile registration form when redisplayed again
    after clicking back button or user sms lock  */
    handleFirstTime({ firstTime }) {
      this.isFirstTime = firstTime
    },
    // handle remaining operations after successful sms security code verification
    securityCodeResponse(event) {
      if (event.response.data.error === false) {
        this.onDefaultClicked()
      }
    },
    // handle back button clicked and user sms locked after 3 wrong input.
    displayMobileRegistration() {
      this.display = 'mobile-input'
      this.isFirstTime = false
    },
    // set error message to display in parent component
    setErrorMessage({ error }) {
      this.errorMessageToParent = error
    },
    // get last four digit of input mobile number
    lastFourNumber() {
      return this.mobileNumber ? this.mobileNumber.substring(this.mobileNumber.length - 4) : ''
    },
    onMobileReturnClicked() {
      this.paymentConfirmShown = false
      this.show('top')
    },
  },
}
</script>
